import { cn } from '@insta-club/utilities';
import Link from 'next/link';
import BreadCrumbProps from './bread-crumbs.types';

const BreadCrumb = ({ links, containerClass = '', labelClass = '', activeClass = '' }: BreadCrumbProps) => {
    return (
        <ul className={cn('flex items-center gap-1', containerClass)}>
            {links.map((item, index) => (
                <li key={`breadCrumbs${index}`}>
                    {item.href ? (
                        <div className='flex items-center gap-1'>
                            <Link className={cn('text-primary-500 text-sm font-semibold', labelClass)} href={item.href}>
                                {item.label}
                            </Link>
                            {/* <ChevronLeftIcon className='mt-0.5 stroke-current text-sm text-gray-500' width='10' /> */}
                            <i>{'>'}</i>
                        </div>
                    ) : (
                        <span className={cn('text-sm font-semibold text-gray-400', activeClass)}>{item.label}</span>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default BreadCrumb;
